// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__Bz5RR","log":"ModalInventoryLogs_log__Ahrmq","date":"ModalInventoryLogs_date__1r6on","userName":"ModalInventoryLogs_userName__3zXOy"};